// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"h0-z","subtitle":"i0-z","wrapper":"j0-z","leftArrow":"k0-z","rightArrow":"l0-z"};